import { useCallback, useState } from 'react';

export interface TagConflictModalState {
  show: boolean;
  conflicts: string[];
  pendingTag: string;
}

const EMPTY_STATE: TagConflictModalState = {
  show: false,
  conflicts: [],
  pendingTag: '',
};

export function useTagConflictModal(defaultFallbackMessage: string) {
  const [tagConflictModal, setTagConflictModal] = useState<TagConflictModalState>(EMPTY_STATE);

  const openTagConflictModal = useCallback(
    (pendingTag: string, conflicts: string[], fallbackMessage?: string) => {
      setTagConflictModal({
        show: true,
        pendingTag,
        conflicts: conflicts.length > 0 ? conflicts : [fallbackMessage || defaultFallbackMessage],
      });
    },
    [defaultFallbackMessage],
  );

  const closeTagConflictModal = useCallback(() => {
    setTagConflictModal(EMPTY_STATE);
  }, []);

  return {
    tagConflictModal,
    openTagConflictModal,
    closeTagConflictModal,
  };
}
